import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AppProvider } from './features/Shared/store/appContext';
import { AppLayout } from './features/Shared/components/AppLayout';
import { I18nextProvider } from 'react-i18next';
import i18n, { i18nWhenReady } from '../resources/panther';
import { useAuth } from 'react-oidc-context';

const queryClient = new QueryClient();

export function App(): React.ReactElement {
  const auth = useAuth();
  const [isI18nInitialized, setIsI18nInitialized] = useState<boolean>(false);

  useEffect(() => {
    i18nWhenReady(() => {
      setIsI18nInitialized(true);
    });
  }, []);

  if (auth.isLoading) {
    return <div>Authenticating...</div>;
  }

  if (auth.error) {
    return (
      <div>Encountered error while Authenticating. {auth.error.message}</div>
    );
  }

  if (!auth.isAuthenticated) {
    auth.signinRedirect();
    return <div>Redirecting to login...</div>;
  }

  // TODO: Logic to be implemented for unauthorized user to display a 403: Resource Forbidden page.
  // This will be implemented during API integration.

  // TODO: Logic to be implemented for authorized user but with limited access to application pages.
  // In this case, based on the profile access, only limited nav items will be shown and if at all the user
  // accessed a route not accessible to him/her, the user will be redirected to Page Not Found.
  // This will be implemented during API integration.

  if (!isI18nInitialized) {
    return <div>Loading translations...</div>;
  }

  return (
    <QueryClientProvider client={queryClient}>
      <AppProvider>
        <I18nextProvider i18n={i18n}>
          <AppLayout>
            <Outlet />
          </AppLayout>
        </I18nextProvider>
      </AppProvider>
    </QueryClientProvider>
  );
}
